import { message } from 'antd';

import { GET, POST } from 'src/network/apiHandler';
import config from 'src/globals';
import { GET_MOVEABLE_ASSETS } from 'src/api/routes';
import {
  SET_MOVEABLE_ASSETS,
  SET_MOVEABLE_ASSETS_LOADER,
} from 'src/common/actions/constants';

const { API_BASE_URL } = config;

export const getMoveableAssets = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_MOVEABLE_ASSETS_LOADER,
    data: true,
  });
  const response = await POST(API_BASE_URL + GET_MOVEABLE_ASSETS, data);
  if (response.isSuccess) {
    dispatch({
      type: SET_MOVEABLE_ASSETS,
      data: response.data,
    });
  } else {
    message.error(response.errorMessage);
  }
  dispatch({
    type: SET_MOVEABLE_ASSETS_LOADER,
    data: false,
  });
};
